import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";
import { formatLocation } from "../lib/cities";
import { CityInput } from "./CityInput";
import { toast } from "sonner";

export const RADII = [25, 50, 100];

export function DistanceFilter({ params, setParams }) {
  const { user } = useAuth();
  const { t } = useLanguage();
  const radius = parseInt(params.get("radius") || "0", 10) || 0;
  const near = params.get("near") || "";
  const [origin, setOrigin] = useState(near || user?.location || "");
  useEffect(() => { setOrigin(near || user?.location || ""); }, [near, user?.location]);

  const apply = (r, from) => {
    const next = new URLSearchParams(params);
    if (r && !from) return toast.error(t("dist_need_city"));
    if (r) { next.set("radius", String(r)); next.set("near", from); }
    else { next.delete("radius"); next.delete("near"); }
    next.delete("page");
    setParams(next);
  };

  return (
    <div data-testid="distance-filter">
      <label className="text-sm font-medium text-[#12234A]">{t("dist_label")}</label>
      <div className="mt-1 grid grid-cols-4 gap-1 rounded-xl bg-slate-100 p-1">
        {[0, ...RADII].map((r) => (
          <button key={r} type="button" onClick={() => apply(r, origin)} data-testid={`distance-${r || "any"}`}
            className={`h-8 rounded-lg text-xs font-semibold transition-colors ${radius === r ? "bg-white text-[#F5551E] shadow-sm" : "text-slate-500 hover:text-[#12234A]"}`}>
            {r ? `${r} km` : t("dist_any")}
          </button>
        ))}
      </div>
      <p className="text-[11px] text-slate-500 mt-2 mb-1">{t("dist_from")}</p>
      <CityInput value={origin} onChange={setOrigin} testid="distance-origin" placeholder={t("dist_pick_city")} className="h-9 rounded-xl text-sm"
        onPick={(c) => { const loc = formatLocation(c.city, c.province); setOrigin(loc); if (radius) apply(radius, loc); }} />
      {!origin && <p className="text-[11px] text-amber-600 mt-1" data-testid="distance-need-city">{t("dist_need_city")}</p>}
    </div>
  );
}
